import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { ThemeToggle } from 'src/components/common/ThemeToggle';
import { cn } from 'src/lib/utils';

function HeaderBreadcrumb({ items }) {
  return (
    <nav className="flex min-w-0" aria-label="Breadcrumb">
      <ol className="inline-flex items-center space-x-1 min-w-0">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li
              key={`${item.href}-${item.label}`}
              className={cn('inline-flex items-center', isLast && 'min-w-0')}
            >
              {index > 0 && (
                <ChevronRight className="w-3.5 h-3.5 text-muted-foreground/50 mx-0.5 flex-shrink-0" />
              )}
              {isLast ? (
                // Long titles ellipsize on one line instead of wrapping —
                // `min-w-0` up the flex chain is what lets truncate actually
                // shrink below its content width here.
                <span
                  className="text-xs font-semibold text-foreground-strong truncate"
                  title={item.label}
                >
                  {item.label}
                </span>
              ) : (
                <Link
                  to={item.href}
                  state={item.state}
                  className="text-xs font-medium text-muted-foreground hover:text-foreground-strong transition-colors whitespace-nowrap"
                >
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

export function PageHeader({ title, actions, breadcrumbs }) {
  return (
    <div
      className="flex items-center p-2 sticky top-0 z-10 headerBg pb-[0.25rem] pt-[0.25rem] min-h-[3.25rem] px-6"
      style={{ borderBottom: '1px solid var(--border)' }}
    >
      <div className="flex items-center gap-2 justify-between w-full">
        <div className="flex items-center gap-2 min-w-0 flex-1">
          {breadcrumbs ? (
            <HeaderBreadcrumb items={breadcrumbs} />
          ) : (
            <h1
              className="relative flex items-center gap-4"
              style={{
                fontSize: '15.5px',
                fontWeight: 700,
                color: 'var(--foreground-strong)',
                letterSpacing: '-0.02em',
              }}
            >
              {title}
            </h1>
          )}
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">
          {actions && (
            <div className="flex items-center gap-2">
              {actions}
              <span className="w-[1px] h-[20px] bg-border" aria-hidden="true" />
            </div>
          )}
          <ThemeToggle />
        </div>
      </div>
    </div>
  );
}
